import styled from 'styled-components';
import { Flex } from '#atoms';

export const Wrapper = styled.section``;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.gray15};
  white-space: pre-wrap;
  margin-bottom: 40px;
`;

export const Add = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
  font-size: 17px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.gray15};
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.gray400};
`;

export const ItemWrapper = styled(Flex)`
  margin-bottom: 24px;
`;
